import React from "react"
import BigBanner from "./components/BigBanner"
import PropTypes from "prop-types"
import Container from "@mui/material/Container"
import { getMediaFor, MEDIA_BREAKPOINT_KEYS } from "style/style_snippets"
import { Typography, useMediaQuery, useTheme } from "@mui/material"

const RootPageWrapper = ({
  children,
  bannerTitle,
  description,
  imgBanner,
  withContainer = false,
  withBottom = true,
  buttonRow,
  disableFading = false
}) => {
  const rootPageWrapperStyle = {
    container: { paddingBottom: withBottom ? "80px" : 0 },

    subContainer: {
      marginTop: 30,
    },

    title: {
      container: {
        ...getMediaFor("paddingTop", "30px", {
          [MEDIA_BREAKPOINT_KEYS.xs]: "30px",
          [MEDIA_BREAKPOINT_KEYS.sm]: "50px",
          [MEDIA_BREAKPOINT_KEYS.lg]: "80px",
        }),
      },
      text: {
        "&:first-letter": { textTransform: "uppercase" },
      },
    },

    description: {
      container: {
        ...getMediaFor("width", "100%", {
          [MEDIA_BREAKPOINT_KEYS.xs]: "90%",
          [MEDIA_BREAKPOINT_KEYS.sm]: "85%",
          [MEDIA_BREAKPOINT_KEYS.lg]: "85%",
        }),
      },
      paragraph: {
        ...getMediaFor("paddingTop", "30px", {
          [MEDIA_BREAKPOINT_KEYS.xs]: "30px",
          [MEDIA_BREAKPOINT_KEYS.sm]: "50px",
          [MEDIA_BREAKPOINT_KEYS.lg]: "80px",
        }),
      },
    },
  }

  const theme = useTheme()

  const mediaMatch = useMediaQuery(
    theme.breakpoints.down(MEDIA_BREAKPOINT_KEYS.xs)
  )

  return (
    <div css={rootPageWrapperStyle.container}>
      <BigBanner {...{ bannerTitle, imgBanner, disableFading }} />

      {mediaMatch && (
        <Container css={rootPageWrapperStyle.title.container} maxWidth={"md"}>
          <Typography css={rootPageWrapperStyle.title.text} variant={"h1"}>
            {bannerTitle}
          </Typography>
        </Container>
      )}

      {description && (
        <Container maxWidth={"md"}>

          {buttonRow && (
          <div>{buttonRow}</div>
        )}
          <div css={rootPageWrapperStyle.description.container}>
            <Typography
              variant={"body1"}
              css={rootPageWrapperStyle.description.paragraph}
            >
              {description}
            </Typography>
          </div>
        </Container>
      )}
      {withContainer ? (
        <Container css={rootPageWrapperStyle.subContainer} maxWidth={"md"}>
          {children}
        </Container>
      ) : (
        <>{children}</>
      )}
    </div>
  )
}

RootPageWrapper.propTypes = {
  bannerTitle: PropTypes.string.isRequired,
  heading: PropTypes.string,
  description: PropTypes.any,
  imgBanner: PropTypes.object.isRequired,
}

RootPageWrapper.defaultProps = {
  heading: `Mercedes-Benz Open Source`,
}

export default RootPageWrapper
